import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDocumentStatus,
  uploadMerchantDocument,
  getDownloadDocument,
} from '@services/documents-service';
import { showError } from '@store/logged/actions';
import { hideLoading, showLoading } from '@store/common/actions';
import { successResponsive } from '@constants/errorObjects';
import { useTranslation } from 'react-i18next';
import { setDocTypeAndQuantity } from '@store/onboarding/actions';

export const useDocument = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [documents, setDocuments] = useState([]);
  const [documentFile, setDocumentFile] = useState(null);
  const [downloadAll, setDownloadAll] = useState(false);

  const { merchant } = useSelector((state) => state.login);

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    getDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchant]);

  const getDocuments = () => {
    dispatch(showLoading());
    getDocumentStatus(merchant.document.doc_number, merchant.document.doc_type)
      .then((response) => {
        dispatch(
          setDocTypeAndQuantity({
            docTypes: response?.document_status,
            quantity: 1,
          })
        );
        const documentsRaw = response.document_status.map((document, idx) => {
          if (document.status === 'APPROVED' || document.status === 'REJECTED') {
            setDownloadAll(true);
          }
          return {
            ...document,
            ...response.files[idx],
          };
        });
        setDocuments(documentsRaw);
      })
      .catch((error) => dispatch(showError(error)))
      .finally(() => dispatch(hideLoading()));
  };

  const addDocument = (documentIndex) => (files) => {
    setDocumentFile({ documentIndex, file: files?.[0] });
  };

  const uploadDocument = (_, id) => {
    dispatch(showLoading());
    uploadMerchantDocument([documentFile.file], {
      doc_number: merchant.document.doc_number,
      doc_type: merchant.document.doc_type,
      document_type: merchant.document_status[id].type,
    })
      .then(() => {
        dispatch(showError(successResponsive(t('documentation.addFiles.success'))));
        getDocuments();
      })
      .catch((error) => {
        dispatch(showError(error));
        dispatch(hideLoading());
      });
  };

  const downloadDocument = async (type) => {
    const response = await getDownloadDocument(type);
    return response;
  };

  const downloadAllDocuments = async () => {
    const readyToDownload = documents.filter(
      (document) => document.status === 'APPROVED' || document.status === 'REJECTED'
    );
    return readyToDownload;
  };

  return {
    downloadAll,
    documents,
    addDocument,
    uploadDocument,
    downloadDocument,
    downloadAllDocuments,
  };
};
